import { roles, rolesArray } from './roles';

export const environment = {
  production: true,
  name: 'prod',
  buildNumber: 'master.d936cca5',
  appName: 'producers-portal',
  appId: 'rtl2RestApi',
  loggerExcludeType: ['INFO', 'NOTICE', 'DEBUG', 'WARNING'],
  clientToken: 'a4a24afe6fff2aef5fbeaa1b5a7eac9d',
  sentryDsn: 'https://8687ff371d5745a08082598a2a97a246@p-sentry.rtl2cloud.de/30',
  authRoles: rolesArray,
  roles,
  urlSsoB2bWebServer: 'https://p-sso-b2b.rtl2apps.de',
  urlBobyApi: 'https://wfp-boby-wapi.rtl2cloud.de',
  producerTexts: 'https://isy.rtl2.de/producer-texts/',
};
